import type { IStore } from '../stores/Store';

let store: IStore;

export const updateClientStore = (_store: IStore) => {
  store = _store;
};

export const getStore = () => store;
